import apiClient, { handleApiError } from '../lib/api-client';
import { API_ENDPOINTS } from '../config/api';

export interface HealthQuestionnaireDto {
  age?: number;
  gender?: string;
  heightCm?: number;
  weightKg?: number;
  waistCircumferenceCm?: number;
  diabetesDiagnosis?: string;
  diabetesDuration?: string;
  hba1cLevel?: number;
  homeBloodSugarCheck?: string;
  fastingReading?: number;
  postMealReading?: number;
  currentMedications?: string[];
  medicationNames?: string;
  recentWeightGain?: boolean;
  healthConditions?: string[];
  physicalActivityLevel?: string;
  averageSleepDuration?: string;
  dietType?: string;
  processedFoodFrequency?: string;
  tobaccoUse?: boolean;
  alcoholIntake?: string;
  symptoms?: string[];
  abdominalWeightGain?: boolean;
  postMealFatigue?: boolean;
  lipidIssues?: boolean;
  rapidHunger?: boolean;
  skinChangesFamilyHistory?: boolean;
  bloatingFattyLiver?: boolean;
  hormonalIssues?: boolean;
}

export const healthQuestionnaireService = {
  async getMine() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.HEALTH_QUESTIONNAIRE.ME);
      return response.data?.data ?? response.data ?? null;
    } catch (error: any) {
      if (error.response?.status === 404) return null;
      throw new Error(handleApiError(error));
    }
  },

  async submit(data: HealthQuestionnaireDto) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.HEALTH_QUESTIONNAIRE.CREATE, data);
      return response.data?.data ?? response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },

  async isCompleted(): Promise<boolean> {
    try {
      const response = await apiClient.get<{ data?: { completed?: boolean }; completed?: boolean }>(
        API_ENDPOINTS.HEALTH_QUESTIONNAIRE.COMPLETED
      );
      const body = response?.data;
      if (body == null || typeof body !== 'object') return false;
      return body?.data?.completed ?? body?.completed ?? false;
    } catch (error) {
      return false;
    }
  },
};
